import { render, staticRenderFns } from "./BrandBotSummary.vue?vue&type=template&id=b0f6e542&scoped=true&"
import script from "./BrandBotSummary.vue?vue&type=script&lang=js&"
export * from "./BrandBotSummary.vue?vue&type=script&lang=js&"
import style0 from "./BrandBotSummary.vue?vue&type=style&index=0&id=b0f6e542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f6e542",
  null
  
)

export default component.exports